import Parseable from '@/misc/Parseable';
import { CategoryApiEntity } from '@/interfaces/CategoryApiEntity.interface';

/**
 * A magazine category
 */
export default class Category extends Parseable {
    id!: string;
    name!: string;

    public static parseFromObject(object: CategoryApiEntity): Category {
        const category = new Category();
        category.id = object.id;
        category.name = object.name;
        return category;
    }

    public parseToObject(): Partial<Category> {
        return { ...this };
    }
}
